export default __webpack_public_path__ + "static/media/coin_eur.f5e4054f.svg";